<template>
  <footer class="footer-container bg-dark">
    <div style="max-width: 1500px; margin: auto">
      <b-row no-gutters class="text-left">
        <b-col cols="12" md="4">
          <div class="mt-5 pl-5 pl-md-5 text-white footer-column">
            <p class="h5 text-primary">
              <b>{{ $t('footer_customerService') }}</b>
            </p>
            <div>
              <router-link to="/help-center" class="white-link">
                Help Center
              </router-link>
            </div>
            <div>
              <router-link to="/order-tracking" class="white-link">
                Track Your Order
              </router-link>
            </div>
            <div>
              <router-link to="/delivery-fee" class="white-link">
                {{ $tc('common_deliveryFee', 2) }}
              </router-link>
            </div>
          </div>
        </b-col>
        <b-col cols="12" md="4">
          <div class="mt-5 pl-5 pl-md-5 text-white footer-column">
            <p class="h5 text-primary"><b>Quick Links</b></p>
            <div>
              <router-link to="/" class="white-link"> Home </router-link>
            </div>
            <div>
              <router-link to="/shops" class="white-link">
                Shop Mart
              </router-link>
            </div>
            <div>
              <router-link to="/products" class="white-link">
                Products
              </router-link>
            </div>
          </div>
        </b-col>
        <b-col cols="12" md="4">
          <div class="mt-5 pl-5 pl-md-2 pr-md-5 text-white footer-column">
            <p class="h5 text-primary">
              <b>{{ $t('footer_contactUs') }}</b>
            </p>
            <div><b>Address :</b> {{ (address && address.value) || '' }}</div>
            <div><b>Phone :</b> {{ (phone && phone.value) || '' }}</div>
            <div><b>Email :</b> {{ (email && email.value) || '' }}</div>
          </div>
        </b-col>
      </b-row>
      <b-row align-h="center" no-gutters>
        <b-col>
          <p class="text-center mt-5 pt-3 pb-4 text-primary">
            <small>
              <a
                :href="copyrightInfo.copyrightNameLink"
                class="text-decoration-none"
                target="_blank"
              >
                Copyright &copy; {{ copyrightInfo.copyrightYear }}
                <!-- {{ new Date().getFullYear() }} -->

                <!-- <img
                  style="height: 18px; margin-bottom: 4px"
                  src="@/assets/images/judo-only.png"
                /> -->
                {{ copyrightInfo.copyrightName }}

                All rights reserved.
              </a>
            </small>
          </p>
        </b-col>
      </b-row>
    </div>
  </footer>
</template>

<script>
export default {
  computed: {
    address() {
      return this.$store.getters.getSetting('ADDRESS');
    },
    phone() {
      return this.$store.getters.getSetting('PHONE');
    },
    email() {
      return this.$store.getters.getSetting('EMAIL');
    },
    footerInfo() {
      return this.$store.getters.getSetting('SITEINFO');
    },
  },
  watch: {
    footerInfo: {
      handler(v) {
        if (v && v.value) {
          const tmp = JSON.parse(v.value);
          this.copyrightInfo = Object.assign({}, tmp);
        }
      },
      immediate: true,
    },
  },
  data: () => ({
    copyrightInfo: '',
  }),
};
</script>
